<h1 mat-dialog-title>{{data.titulo}}</h1>
<div mat-dialog-content>
  <p>{{data.mensagem}} 
  <!--Para utilizar browser Chrome instale o criptoCNS e/ou habilite as extensões Kriptonita conforme o passo a passo -->
  <button mat-icon-button	(click)="openDialogHelp()" *ngIf="existsHelp()" title="Como ativar as extensões?" >
    <img class="img-fluid" src="assets/icons/help.png"  width="24px"/>
  </button>
</p>
</div>
<div mat-dialog-actions class="botoes">
  <button mat-raised-button *ngIf="mostraBtnConfirma" class="md-icon-button btnOK" (click)="onYesClick()" cdkFocusInitial>
    <img class="img-fluid" src="assets/icons/save_alt_white.png"  width="24px"/> {{data.labelconfirmar}}
  </button>
  <button mat-raised-button *ngIf="!existsHelp()" class="md-icon-button btnNok" (click)="onNoClick()">
    <img class="img-fluid" src="assets/icons/white_close_icon.png"  width="16px"/> {{data.labelcancelar}}
  </button>
</div>

<!--
<h1 mat-dialog-title>{{data.titulo}}</h1>
<div mat-dialog-content>
  <div [innerHTML]="txtMensagem"></div> 
  <div class="interrogacao"><button mat-icon-button	(click)="openDialogHelp()" *ngIf="existsHelp()" title="Como ativar as extensões?" >
    <img class="img-fluid" src="assets/icons/help.png"  width="24px"/>
  </button></div>
</div>
<div mat-dialog-actions class="botoes">
  <button mat-raised-button *ngIf="mostraBtnConfirma" class="md-icon-button btnOK" (click)="onYesClick()" cdkFocusInitial>
    <img class="img-fluid" src="assets/icons/save_alt_white.png"  width="24px"/> {{data.labelconfirmar}}
  </button>
  <button mat-raised-button *ngIf="existsHelp()" class="md-icon-button btnNok" (click)="onNoClick()">
    <img class="img-fluid" src="assets/icons/white_close_icon.png"  width="16px"/> {{data.labelcancelar}}
  </button>
</div>
-->